import { buildSelector } from '@/shared/lib/store';

export const [useLastUpdatedTime] = buildSelector(
    (state) => state.patternLive?.lastUpdated ?? undefined,
);

export const [usePinnedUniqueId] = buildSelector(
    (state) => state.patternLive?.pinnedUniqueId ?? undefined,
);
